import { handleApiError } from '@/api/util'
import ticket3PageApi from '@/api/ticket3/page.js'
export default {
  methods: {
    async getWrapUpByName({ pageid, wrapUpName }) {
      try {
        const response = await ticket3PageApi.getWrapUpRoute({
          params: {
            page_id: pageid,
            limit: 1,
            offset: 0,
            wrap_up: wrapUpName
          }
        })
        if (response.status == 200) {
          return response.data.data || []
        }
      } catch (error) {
        await handleApiError(error)
      }
    },
    async handleSaveWrapUp({ pageid, currentWrapUp }) {
      const wrapUpSameName = await this.getWrapUpByName({
        pageid,
        wrapUpName: currentWrapUp.wrap_up
      })
      // check if wrap up name and not same id with current wrap up
      if (wrapUpSameName.length > 0 && wrapUpSameName[0].id !== currentWrapUp.id) {
        await this.$swal.fire({
          title: 'Please use another wrap up name',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
      try {
        const response = await ticket3PageApi.postWrapUpRoute({
          data: {
            page_id: pageid,
            wrap_up: currentWrapUp.wrap_up,
            wrap_up_route: this.convertWrapUpRoute(currentWrapUp.wrap_up_route)
          }
        })
        if (response.status == 200 || response.status == 204) {
          return true
        }
      } catch (error) {
        await handleApiError(error)
        return false
      }
    },
    convertWrapUpRoute(wrapUpRoute) {
      return wrapUpRoute.map((route) => {
        return {
          level_1: { ...this.convertSubWrapUpRoute(route.subWrapUp), title: route.title }
        }
      })
    },
    convertSubWrapUpRoute(subWrapUpRoute) {
      if (!subWrapUpRoute || subWrapUpRoute.length == 0) return {}
      const level = subWrapUpRoute[0].level

      return {
        [`level_${level}`]: subWrapUpRoute.map((route) => {
          return {
            title: route.title,
            ...this.convertSubWrapUpRoute(route.subWrapUp)
          }
        }, [])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/ticket3/ticket-management/WrapUp/WrapUpMixin.js